<div class="container-fluid p-0">
    <div class="hpanel">
        <div class="panel-body b-r-6">
            <div class="card">
                <div class="card-header p-10-30">
                    <h6> Manage workspaces for your organization</h6>
                </div>
                <div class="card-body">
                  <ng-container *ngIf="isBusinessOrEnterpriseUser; else showUpgradeMessage">
                    <app-plan-card [cards]="allocationCards" [TOTAL]="PLANMAX"></app-plan-card>
                    <div class="row">
                        <div class="col-sm-12">
                            <app-customer-search [placeholder]="'Search by workspace name, user or email'"></app-customer-search>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 custom-datatable">
                            <!-- Empty state -->
                            <div *ngIf="listToShow?.length === 0" class="datatable-empty-state">
                              <app-nodata-found
                                [title]="['No workspaces found']"
                                [screen]="'EMPTY'"
                                [buttonShow]="false">
                              </app-nodata-found>
                            </div>

                            <!-- Datatable with data -->
                            <div *ngIf="listToShow?.length > 0">
                                <ngx-datatable #sortTable class="bootstrap" [rows]="listToShow" [columnMode]="'force'"
                                    [footerHeight]="50" (sort)="onSort($event)" [rowHeight]="'auto'" [limit]="10" [headerHeight]="45"
                                    [selectAllRowsOnPage]="false" (select)='onSelect($event)' (page)="nextPage($event)"
                                    [externalPaging]="true" [count]="userPayload.total" [scrollbarH]="true"
                                    [offset]="userPayload.page - 1">
                                    <ngx-datatable-column cellClass="custom-cell" name="Workspace Name" prop="teamName">
    
                                      <ng-template let-row="row" ngx-datatable-cell-template>
                                        <ng-container *ngIf="role !== 'EMPLOYEE' && role !== 'ADMIN'; else plainText">
    
                                          <a class="listinglink" [routerLink]="['/user-management/workSpace/details']"
                                            [queryParams]="getWorkspaceParams(row)"
                                            routerLinkActive="router-link-active">
                                            {{ row.teamName }}
                                          </a>
                                        </ng-container>
                                        <ng-template #plainText>
                                          {{ row.teamName }}
                                        </ng-template>
                                      </ng-template>
    
    
                                    </ngx-datatable-column>
                                    <ngx-datatable-column [width]="200" name="User" prop="owner">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            {{row?.owner}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column [width]="200" name="Email ID" prop="username">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            {{row?.username}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="Role" prop="userType" [width]="120">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            {{row?.userType | MTAPipe: 'convertMTA' | titlecase}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="Members" prop="memberCnt">
                                    </ngx-datatable-column>
                                    <ngx-datatable-column cellClass="colValuesync" name="Start Date" prop="createdOn" [width]="120">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            <label>
                                                {{row.createdOn | timezoneDate:'MM/dd/yyyy'}}
                                            </label>
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column cellClass="colValuesync" name="Last Active" prop="lastLoggedIn" [width]="120">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            <label>
                                                {{row.modifiedOn | timezoneDate:'MM/dd/yyyy'}}
                                            </label>
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column cellClass="colValuesync" name="Status" prop="status" [width]="120">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            <label
                                                [ngClass]="{'active-status-table': row.status === 'ACTIVE', 'inactive-status-table': row.status === 'INACTIVE'|| row.status === 'DEACTIVATED' }"
                                                class="capitalize-first">{{ row.status}}</label>
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ng-container >
                                      <ngx-datatable-column cellClass="colValuesync" name="Actions" prop="name"  [width]="120">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                          <div class="wrapper">
                                            <span class="action-items">
                                              <ng-icon name="tablerEye" class="svg-position" (click)="openEdit(row)"></ng-icon>
                                            </span>
                                            <span class="action-items"*ngIf="role !== 'EMPLOYEE'&&role!='ADMIN'">
                                              <ng-icon name="tablerPencil" [routerLink]="['/user-management/workSpace/details']"
                                                  [queryParams]="getTeamParams(row)"
                                                  routerLinkActive="router-link-active" class="svg-position"></ng-icon>
                                            </span>
                                          </div>
                                        </ng-template>
                                      </ngx-datatable-column>
                                    </ng-container>
                                </ngx-datatable>
                            </div>
                        </div>
                    </div>
                    </ng-container>
                    <ng-template #showUpgradeMessage>
                      <app-upgrade-message
    
                        [allocationCards]="allocationCards">
                      </app-upgrade-message>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>


<ng-container *ngIf="slotModalOpen">
    <app-manage-slot [title]="'Workspace Allocations'" [userData]="slotData | async " [planDetails]="slotPlanDetails"
        [KEY]="'TEAM_WORKSPACES'" [content]="'workSpace'" (close)="onClose($event)" (onScroll)="onScroll()"
        (onSucess)="onSucess($event)" [this]="this" (onSearch)="onSearch($event)"
        (onAllocate)="slotAllocatedCards = $event"
        [allocationCards]="slotAllocatedCards"
        >

        <app-plan-card planCards [cards]="slotAllocatedCards" [TOTAL]="PLANMAX"></app-plan-card>

        <ng-container header>
            <th>User Name</th>
            <th>Email ID</th>
            <th>Role</th>
            <th>Allocated</th>
            <th>Utilized</th>
            <th>New Allocation</th>
        </ng-container>

    </app-manage-slot>
</ng-container>
